<template>
   <svg viewBox="0 0 95 51" fill="none" aria-hidden="true" focusable="false">
      <path d="M95 -1.66103e-05L0 0L8.91712e-06 51L95 51L95 -1.66103e-05Z" fill="#B22234" />
      <path
         d="M0 5.88464L95 5.88463L0 5.88464ZM95 13.7308L1.37187e-06 13.7308L95 13.7308ZM2.74373e-06 21.577L95 21.5769L2.74373e-06 21.577ZM95 29.4231L4.1156e-06 29.4231L95 29.4231ZM5.48746e-06 37.2693L95 37.2692L5.48746e-06 37.2693ZM95 45.1154L6.85933e-06 45.1154L95 45.1154Z"
         fill="black"
      />
      <path
         d="M95 47.0769L7.54526e-06 47.0769L6.85933e-06 43.1539L95 43.1538L95 47.0769ZM95 39.2308L6.17339e-06 39.2308L5.48746e-06 35.3077L95 35.3077L95 39.2308ZM95 31.3846L4.80153e-06 31.3846L4.1156e-06 27.4616L95 27.4615L95 31.3846ZM95 23.5385L3.42966e-06 23.5385L2.74373e-06 19.6154L95 19.6154L95 23.5385ZM95 15.6923L2.0578e-06 15.6923L1.37187e-06 11.7692L95 11.7692L95 15.6923ZM95 7.84616L6.85933e-07 7.84617L0 3.9231L95 3.92308L95 7.84616Z"
         fill="white"
      />
      <path d="M38 -6.64413e-06L0 0L4.80152e-06 27.4615L38 27.4615L38 -6.64413e-06Z" fill="#3C3B6E" />
      <path
         d="M3.16688 1.17688L4.07072 4.01562L1.7038 2.26122L4.62688 2.26122L2.26226 4.01562L3.16688 1.17688Z"
         fill="white"
      />
      <path
         d="M3.16694 6.66919L4.07078 9.50794L1.70386 7.75353L4.62694 7.75353L2.26232 9.50794L3.16694 6.66919Z"
         fill="white"
      />
      <path
         d="M3.16694 12.1615L4.07078 15.0002L1.70386 13.2458L4.62694 13.2458L2.26232 15.0002L3.16694 12.1615Z"
         fill="white"
      />
      <path
         d="M3.16694 17.6538L4.07078 20.4925L1.70386 18.7381L4.62694 18.7381L2.26232 20.4925L3.16694 17.6538Z"
         fill="white"
      />
      <path
         d="M3.16694 23.1461L4.07078 25.9849L1.70386 24.2305L4.62694 24.2305L2.26232 25.9849L3.16694 23.1461Z"
         fill="white"
      />
      <path
         d="M6.33301 3.9231L7.23762 6.76183L4.86993 5.00743L7.79301 5.00743L5.42916 6.76183L6.33301 3.9231Z"
         fill="white"
      />
      <path
         d="M6.33301 9.41541L7.23762 12.2541L4.86993 10.4997L7.79301 10.4997L5.42916 12.2541L6.33301 9.41541Z"
         fill="white"
      />
      <path
         d="M6.33301 14.9077L7.23762 17.7465L4.86993 15.9921L7.79301 15.9921L5.42916 17.7465L6.33301 14.9077Z"
         fill="white"
      />
      <path
         d="M6.33301 20.4L7.23762 23.2388L4.86993 21.4844L7.79301 21.4844L5.42916 23.2388L6.33301 20.4Z"
         fill="white"
      />
      <path
         d="M9.50001 1.17688L10.4046 4.01562L8.03693 2.26122L10.96 2.26122L8.59539 4.01562L9.50001 1.17688Z"
         fill="white"
      />
      <path
         d="M9.50001 6.66919L10.4046 9.50794L8.03693 7.75353L10.96 7.75353L8.59231 9.50794L9.50001 6.66919Z"
         fill="white"
      />
      <path
         d="M9.50001 12.1615L10.4046 15.0002L8.03693 13.2458L10.96 13.2458L8.59231 15.0002L9.50001 12.1615Z"
         fill="white"
      />
      <path
         d="M9.50001 17.6538L10.4046 20.4925L8.03693 18.7381L10.96 18.7381L8.59231 20.4925L9.50001 17.6538Z"
         fill="white"
      />
      <path
         d="M9.50001 23.1461L10.4046 25.9849L8.03693 24.2305L10.96 24.2305L8.59231 25.9849L9.50001 23.1461Z"
         fill="white"
      />
      <path
         d="M12.6669 3.9231L13.5707 6.76183L11.2038 5.00743L14.1269 5.00743L11.7623 6.76183L12.6669 3.9231Z"
         fill="white"
      />
      <path
         d="M12.6669 9.41541L13.5707 12.2541L11.2038 10.4997L14.1269 10.4997L11.7592 12.2541L12.6669 9.41541Z"
         fill="white"
      />
      <path
         d="M12.6669 14.9077L13.5707 17.7465L11.2038 15.9921L14.1269 15.9921L11.7592 17.7465L12.6669 14.9077Z"
         fill="white"
      />
      <path
         d="M12.6669 20.4L13.5707 23.2388L11.2038 21.4844L14.1269 21.4844L11.7592 23.2388L12.6669 20.4Z"
         fill="white"
      />
      <path
         d="M15.833 1.17688L16.7376 4.01562L14.3699 2.26122L17.293 2.26122L14.9292 4.01562L15.833 1.17688Z"
         fill="white"
      />
      <path
         d="M15.833 6.66919L16.7376 9.50794L14.3699 7.75353L17.293 7.75353L14.9261 9.50794L15.833 6.66919Z"
         fill="white"
      />
      <path
         d="M15.833 12.1615L16.7376 15.0002L14.3699 13.2458L17.293 13.2458L14.9261 15.0002L15.833 12.1615Z"
         fill="white"
      />
      <path
         d="M15.833 17.6538L16.7376 20.4925L14.3699 18.7381L17.293 18.7381L14.9261 20.4925L15.833 17.6538Z"
         fill="white"
      />
      <path
         d="M15.833 23.1461L16.7376 25.9849L14.3699 24.2305L17.293 24.2305L14.9261 25.9849L15.833 23.1461Z"
         fill="white"
      />
      <path d="M19 3.9231L19.9046 6.76183L17.5385 5.00743L20.4615 5.00743L18.0954 6.76183L19 3.9231Z" fill="white" />
      <path d="M19 9.41541L19.9046 12.2541L17.5385 10.4997L20.4615 10.4997L18.0938 12.2541L19 9.41541Z" fill="white" />
      <path d="M19 14.9077L19.9046 17.7465L17.5385 15.9921L20.4615 15.9921L18.0938 17.7465L19 14.9077Z" fill="white" />
      <path d="M19 20.4L19.9046 23.2388L17.5385 21.4844L20.4615 21.4844L18.0938 23.2388L19 20.4Z" fill="white" />
      <path
         d="M22.1669 1.17688L23.0707 4.01562L20.7038 2.26122L23.6269 2.26122L21.2623 4.01562L22.1669 1.17688Z"
         fill="white"
      />
      <path
         d="M22.1669 6.66919L23.0707 9.50794L20.7038 7.75353L23.6269 7.75353L21.2592 9.50794L22.1669 6.66919Z"
         fill="white"
      />
      <path
         d="M22.1669 12.1615L23.0707 15.0002L20.7038 13.2458L23.6269 13.2458L21.2592 15.0002L22.1669 12.1615Z"
         fill="white"
      />
      <path
         d="M22.1669 17.6538L23.0707 20.4925L20.7038 18.7381L23.6269 18.7381L21.2592 20.4925L22.1669 17.6538Z"
         fill="white"
      />
      <path
         d="M22.1669 23.1461L23.0708 25.9849L20.7039 24.2305L23.6269 24.2305L21.2592 25.9849L22.1669 23.1461Z"
         fill="white"
      />
      <path
         d="M25.333 3.9231L26.2376 6.76183L23.8699 5.00743L26.793 5.00743L24.4292 6.76183L25.333 3.9231Z"
         fill="white"
      />
      <path
         d="M25.333 9.41541L26.2376 12.2541L23.8699 10.4997L26.793 10.4997L24.4261 12.2541L25.333 9.41541Z"
         fill="white"
      />
      <path
         d="M25.333 14.9077L26.2376 17.7465L23.8699 15.9921L26.793 15.9921L24.4261 17.7465L25.333 14.9077Z"
         fill="white"
      />
      <path d="M25.333 20.4L26.2376 23.2388L23.8699 21.4844L26.793 21.4844L24.4261 23.2388L25.333 20.4Z" fill="white" />
      <path
         d="M28.5 1.17688L29.4046 4.01562L27.0369 2.26122L29.96 2.26122L27.5954 4.01562L28.5 1.17688Z"
         fill="white"
      />
      <path
         d="M28.5 6.66919L29.4046 9.50794L27.0369 7.75353L29.96 7.75353L27.5923 9.50794L28.5 6.66919Z"
         fill="white"
      />
      <path
         d="M28.5 12.1615L29.4046 15.0002L27.0369 13.2458L29.96 13.2458L27.5923 15.0002L28.5 12.1615Z"
         fill="white"
      />
      <path
         d="M28.5 17.6538L29.4046 20.4925L27.0369 18.7381L29.96 18.7381L27.5923 20.4925L28.5 17.6538Z"
         fill="white"
      />
      <path
         d="M28.5001 23.1461L29.4047 25.9849L27.037 24.2305L29.9601 24.2305L27.5924 25.9849L28.5001 23.1461Z"
         fill="white"
      />
      <path
         d="M31.6669 3.9231L32.5708 6.76183L30.2039 5.00743L33.1269 5.00743L30.7623 6.76183L31.6669 3.9231Z"
         fill="white"
      />
      <path
         d="M31.6669 9.41541L32.5708 12.2541L30.2039 10.4997L33.1269 10.4997L30.7592 12.2541L31.6669 9.41541Z"
         fill="white"
      />
      <path
         d="M31.6669 14.9077L32.5708 17.7465L30.2039 15.9921L33.1269 15.9921L30.7592 17.7465L31.6669 14.9077Z"
         fill="white"
      />
      <path
         d="M31.6669 20.4L32.5708 23.2388L30.2039 21.4844L33.1269 21.4844L30.7592 23.2388L31.6669 20.4Z"
         fill="white"
      />
      <path
         d="M34.8331 1.17688L35.7377 4.01562L33.37 2.26122L36.2931 2.26122L33.9292 4.01562L34.8331 1.17688Z"
         fill="white"
      />
      <path
         d="M34.8331 6.66919L35.7377 9.50794L33.37 7.75353L36.2931 7.75353L33.9262 9.50794L34.8331 6.66919Z"
         fill="white"
      />
      <path
         d="M34.8331 12.1615L35.7377 15.0002L33.37 13.2458L36.2931 13.2458L33.9262 15.0002L34.8331 12.1615Z"
         fill="white"
      />
      <path
         d="M34.8331 17.6538L35.7377 20.4925L33.37 18.7381L36.2931 18.7381L33.9262 20.4925L34.8331 17.6538Z"
         fill="white"
      />
      <path
         d="M34.8331 23.1461L35.7377 25.9849L33.37 24.2305L36.2931 24.2305L33.9262 25.9849L34.8331 23.1461Z"
         fill="white"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
